var BootstrapperError = /** @class */ (function () {
    function BootstrapperError(name, message, rootCorrelationId, isExpected, statusCode, numberOfRetries) {
        this.name = name;
        this.message = message;
        this.rootCorrelationId = rootCorrelationId;
        this.isExpected = isExpected;
        this.statusCode = statusCode;
        this.numberOfRetries = numberOfRetries;
    }
    return BootstrapperError;
}());
export { BootstrapperError };
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiQm9vdHN0cmFwcGVyRXJyb3IuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvTW9kZWxzL0Jvb3RzdHJhcHBlckVycm9yLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBO0lBQ0UsMkJBQ1MsSUFBMkIsRUFDM0IsT0FBZ0IsRUFDaEIsaUJBQTBCLEVBQzFCLFVBQW9CLEVBQ3BCLFVBQW1CLEVBQ25CLGVBQXdCO1FBTHhCLFNBQUksR0FBSixJQUFJLENBQXVCO1FBQzNCLFlBQU8sR0FBUCxPQUFPLENBQVM7UUFDaEIsc0JBQWlCLEdBQWpCLGlCQUFpQixDQUFTO1FBQzFCLGVBQVUsR0FBVixVQUFVLENBQVU7UUFDcEIsZUFBVSxHQUFWLFVBQVUsQ0FBUztRQUNuQixvQkFBZSxHQUFmLGVBQWUsQ0FBUztJQUM5QixDQUFDO0lBQ04sd0JBQUM7QUFBRCxDQUFDLEFBVEQsSUFTQyJ9